// VRG-138 REDESIGN (VERA-891): global VERA shipping-box presets — PLATFORM MIRROR.
//
// Canonical source is `@repo/types` (store/shipping-box-preset.ts), consumed by
// the API. The platform mirrors it here because `@repo/types` is a type-only
// dependency of `apps/platform` (its imports are erased by esbuild) — importing
// runtime VALUES from it fails Vite resolution. This mirrors the same
// convention as `OrderShipment` (store) ↔ the API mapper. Keep the values in
// sync with `@repo/types` if the box catalogue changes.

export type ShippingBoxPresetId = 'small' | 'medium' | 'large'

export interface ShippingBoxPreset {
  id: ShippingBoxPresetId
  /** Matches the Shopify saved-package name (e.g. "Small shipping box"). */
  label: string
  lengthIn: number
  widthIn: number
  heightIn: number
  /** Empty-box weight in ounces (mock). */
  tareOz: number
}

// Dimensions match the merchant's actual Shopify saved packages (Shopify
// exposes no API to read them, so Vera mirrors them here). Tare is 0 (the
// Shopify boxes are configured at 0 lb).
export const SHIPPING_BOX_PRESETS: Record<ShippingBoxPresetId, ShippingBoxPreset> = {
  small: { id: 'small', label: 'Small Shipping Box', lengthIn: 24, widthIn: 24, heightIn: 12, tareOz: 0 },
  medium: { id: 'medium', label: 'Medium Shipping Box', lengthIn: 24, widthIn: 24, heightIn: 24, tareOz: 0 },
  large: { id: 'large', label: 'Large Shipping Box', lengthIn: 36, widthIn: 36, heightIn: 18, tareOz: 0 },
}

export const SHIPPING_BOX_PRESET_LIST: ShippingBoxPreset[] = [
  SHIPPING_BOX_PRESETS.small,
  SHIPPING_BOX_PRESETS.medium,
  SHIPPING_BOX_PRESETS.large,
]

export const DEFAULT_SHIPPING_BOX_PRESET: ShippingBoxPresetId = 'medium'

/** MOCK weight of a single Vera package (box of tags), in ounces. */
export const MOCK_PACKAGE_WEIGHT_OZ = 4

/** Suggested total shipment weight = packed packages' (mock) weights + box tare. */
export const computeShipmentWeightOz = (
  packageCount: number,
  boxPreset: ShippingBoxPresetId,
): number => packageCount * MOCK_PACKAGE_WEIGHT_OZ + SHIPPING_BOX_PRESETS[boxPreset].tareOz
